import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function updateCategoryStatus(reqData) {
  try {
    const res = await post(`${URL.updateWOCategoryStatus}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
